import React, {useContext, useEffect} from "react";
import {Link, Navigate} from 'react-router-dom'

import {Loading} from '../custom/LoadingComponent'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import ClientTabsRenderer from './ClientTabsRendererComponent';
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';
import BucketContext from "../context/BucketContext";


const ClientManagement = (props) => {
    const bucketContext = useContext(BucketContext);

    console.log('___ ClientManagement ___');

    useEffect(() => {
        if(bucketContext.bucket.mostRecentClientId != null) {
            console.log('Reseting the mostRecentClientId: ' + JSON.stringify(bucketContext.bucket.mostRecentClientId));
            bucketContext.setBucketValue({mostRecentClientId: null});
        }
        if(props.client) {
            // client can be null if the component refreshes when clients are reloaded
            props.loadComponentData(props.client.id);
        }
    }, [props.client]);

    if(props.dataStatus === ReduxDataStatus.IDLE || 
       props.dataStatus === ReduxDataStatus.LOADING) {
         return (
            <Container maxWidth="xl" >
                <Box px={{ xs: 3, sm: 7 }}>
                    <Loading />
                </Box>
            </Container>
        );
    }
    else if (props.client != null) {
        return (
            <Container maxWidth="xl" >
                <Box px={{ xs: 3, sm: 7 }}>

                    <Stack spacing={1} sx={{ marginBottom: 2 }}>
                        <Box>
                            <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                                <Link to='/clients'>Clienti</Link>
                                <Typography color="text.primary">{props.client.generalSection.clientName}</Typography>
                            </Breadcrumbs>
                        </Box>

                        <Box>
                            <h3>{props.client.generalSection.clientName}</h3>
                        </Box>
                        <hr />

                        <ClientTabsRenderer
                            client={props.client}
                            clientSubcontractanti={props.clientSubcontractanti}
                            clientSubcontracted={props.clientSubcontracted}
                            allClients={props.allClients}
                            patchClient={props.patchClient}
                        />

                    </Stack>

                </Box>
            </Container>
        );
    } else {
        console.log('Here Here....')

        return (
            <div></div>
        );
    }
}


export default ClientManagement